import {
  ExportOptions,
  ExportPayloadSection,
  SerializeExportProgress,
} from '../types';
import {
  SerializeExportResult,
  serializeExportContent,
} from './serializeExportContent';
import { FALLBACK_YIELD_EVERY_N_ROWS } from '../constants';

export const runFallback = async (
  sections: ExportPayloadSection[],
  options: ExportOptions,
  onProgress: SerializeExportProgress | undefined,
  signal: AbortSignal | undefined
): Promise<SerializeExportResult> => {
  if (signal?.aborted) {
    throw new DOMException('Export cancelled', 'AbortError');
  }

  // Wrap onProgress so the fallback can short-circuit when the user cancels mid-run.
  const wrappedProgress: SerializeExportProgress = (processed, total) => {
    if (signal?.aborted) {
      throw new DOMException('Export cancelled', 'AbortError');
    }
    onProgress?.(processed, total);
  };

  return serializeExportContent(
    sections,
    options,
    wrappedProgress,
    FALLBACK_YIELD_EVERY_N_ROWS
  );
};
